import fetchHandler from "../../utils/fetchHandler";
import { MOTIVATION_MANAGEMENT } from "../types/actions";

export const getMotivationList = () => {
    const fetchOptions = {
        url: `/api/motivational`,
        method: "GET",
        actionType: MOTIVATION_MANAGEMENT.GET_MOTIVATION_LIST
    };
    return fetchHandler(fetchOptions);
};

export const addNewMotivation = (values, fileType, successHandler, errorHandler) => {
    let fetchOptions;
    if (fileType === "video") {
        fetchOptions = {
            url: `/api/motivational`,
            method: "POST",
            actionType: MOTIVATION_MANAGEMENT.ADD_NEW_MOTIVATION_SUCCESS,
            body: JSON.stringify(values)
        };
    } else if (fileType === "image") {
        fetchOptions = {
            url: `/api/motivational`,
            method: "POST",
            actionType: MOTIVATION_MANAGEMENT.ADD_NEW_MOTIVATION_SUCCESS,
            body: values,
            isFileUpload: true
        };
    }
    return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const updateMotivation = (values, adId, successHandler, errorHandler) => {
    const fetchOptions = {
        url: `/api/motivational/${adId}`,
        method: "PUT",
        actionType: MOTIVATION_MANAGEMENT.UPDATE_MOTIVATION_SUCCESS,
        body: JSON.stringify(values)
    };
    return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const deleteMotivation = (deleteItem, successHandler) => {
    const fetchOptions = {
        url: `/api/motivational/${deleteItem.id}`,
        method: "DELETE",
        actionType: MOTIVATION_MANAGEMENT.DELETE_MOTIVATION_SUCCESS
    };
    return fetchHandler(fetchOptions, successHandler);
};
